<template>
  <div class="flex items-center justify-center capitalize space-x-2">
    <icon-base
      v-if="iconConfig"
      :icon="iconConfig.icon"
      :class="iconConfig.class"
      height="15"
      width="15"
      view-box="-1 0 15 15"
    />
    <div>{{ value ?? "-" }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { prioritiesIconsMap } from "@/helpers/constants/priorities";

import IconBase from "@/components/ui/IconBase.vue";

import type { Priority } from "@/models/applications";

const props = defineProps<{
  value?: Priority | null;
}>();

const iconConfig = computed(() => {
  if (!props.value || props.value === "none") {
    return null;
  }

  return prioritiesIconsMap[props.value];
});
</script>
